import {billingSvg as Icon__small__billingSvg} from '../Icon__small/Icon__small--billing.js'
import {billingSvg as Icon__xsmall__billingSvg} from '../Icon__xsmall/Icon__xsmall--billing.js'

export var billing = {
  name: 'billing',
  category: 'icon',
  colorable: true,
  svg: Icon__small__billingSvg,
  alt: {
    Icon__small: Icon__small__billingSvg,
    Icon__xsmall: Icon__xsmall__billingSvg
  },
  combined: ['Icon__small', 'Icon__xsmall']
};
